import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import messages from './messages';
import { statsService } from 'utils/api';

import session from 'containers/App/session';

import { FormattedMessage, useIntl } from 'react-intl';
import { Tooltip, message } from 'antd';
import { LoadingOutlined, ReloadOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import CreationUpdateModal from './CreationUpdateModal';
import DisplayTable from './DisplayTable';
import Button from 'components/forms/Button';
import { sortBy } from 'lodash';

const ActionsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 15px;
    & > * {
        margin-left: 10px;
    }
`;

const NotesManagement = ({ start, end }) => {
    const intl = useIntl();
    const token = useSelector(session.selectors.selectUserToken);
    const propertyId = useSelector(session.selectors.selectSelectedPropertyId);
    const [editionModalState, setEditionModalState] = useState({
        open: false,
    });
    const [notes, setNotes] = useState([]);
    const [fetching, setFetching] = useState(false);

    const fetchNotes = async () => {
        setFetching(true);
        const notesResponse = await statsService({
            token,
            propertyId,
        }).getNotes({
            start,
            end,
        });
        setFetching(false);
        if (notesResponse?.data) {
            setNotes(sortBy(notesResponse?.data, ['stayDate']));
        }
    };

    const deleteNote = async (id) => {
        setFetching(true);
        try {
            await statsService({
                token,
                propertyId,
                resourceId: id,
            }).deleteNote();
            fetchNotes();
            message.success(intl.formatMessage(messages.deleteSuccessMessage));
        } catch (err) {
            message.error(intl.formatMessage(messages.deleteErrorMessage));
        }
        setFetching(false);
    };

    useEffect(() => {
        // on mount
        fetchNotes();
    }, [propertyId, start, end]);

    const openModalForCreation = () => {
        setEditionModalState({
            open: true,
            values: {
                startDate: start,
                endDate: end,
                note: null,
            },
        });
    };
    const openModalForEdition = (stayDate) => {
        const note = notes.find((row) => row.stayDate === stayDate);
        setEditionModalState({
            open: true,
            allowEditingDateRange: false,
            values: {
                startDate: stayDate,
                endDate: stayDate,
                ...note,
            },
        });
    };
    const closeEditionModal = () => {
        fetchNotes();
        setEditionModalState({ open: false });
    };

    let content;
    if (fetching) {
        content = (
            <>
                <LoadingOutlined
                    style={{
                        marginRight: '8px',
                        verticalAlign: 'text-bottom',
                    }}
                />
                <FormattedMessage {...messages.loadingMessage} />
            </>
        );
    } else {
        const onClickCreate = () => openModalForCreation();
        content = (
            <div>
                <ActionsContainer>
                    <Button name="addNewBtn" onClick={onClickCreate}>
                        <FormattedMessage {...messages.addNewBtn} />
                    </Button>

                    <Tooltip title={<FormattedMessage {...messages.refreshTooltip} />} placement="left">
                        <Button name="refreshDataButton" icon={<ReloadOutlined />} onClick={fetchNotes} />
                    </Tooltip>
                </ActionsContainer>
                <DisplayTable
                    fetching={fetching}
                    data={notes}
                    onClickEdit={openModalForEdition}
                    onClickDelete={deleteNote}
                />
            </div>
        );
    }
    return (
        <>
            <CreationUpdateModal {...editionModalState} onClose={closeEditionModal} />
            {content}
        </>
    );
};

export default NotesManagement;
